// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle-" + {"513":"e9808ecbddae462d3ced","890":"77c2bd81fc8ca571bae6"}[chunkId] + ".min.js";
};